<template>
  <router-link
    :to="href"
    :style="computedStyle"
    class="vue-link"
  >
    {{ text }}
  </router-link>
</template>

<script>
export default {
  name: "Link",
  props: {
    href: {
      type: [String, Object],
      required: true
    },
    color: {
      type: String,
      default: "$corPrimary" // Ex: "$corPrimary"
    },
    fontSize: {
      type: String,
      default: "16px"
    },
    underline: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    computedStyle() {
      const cssVarName = this.color
        .replace(/^\$/, "--")
        .replace(/([A-Z])/g, "-$1")
        .toLowerCase()

      const resolvedColor = getComputedStyle(document.documentElement).getPropertyValue(cssVarName)?.trim()

      return {
        color: resolvedColor || "#000",
        textDecoration: this.underline ? "underline" : "none",
        fontSize: this.fontSize,
        cursor: "pointer"
      }
    }
  }
};
</script>

<style scoped>
.vue-link:hover {
  opacity: 0.8;
}
</style>
